import reportActions from "containers/BudgetHome/Overview/_actions";

export const clearPlanningReport = () => ({ type: reportActions.PLANNING_DATA_CLEAR });
